/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSFremdkosten from '../../models/TSFremdkosten';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Fremdkosten
 *
 * */
export default class FremdkostenRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public saveFremdkosten(schadenfallId: string, fremdkosten?: TSFremdkosten): IPromise<TSFremdkosten | undefined> {
        if (fremdkosten) {
            let restFremdkosten: any = fremdkosten.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'fremdkosten/' + encodeURIComponent(schadenfallId), restFremdkosten)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSFremdkosten().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public deleteFremdkosten(fremdkosten: TSFremdkosten): IPromise<any> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'fremdkosten/' + encodeURIComponent(fremdkosten.id))
            .then((response) => {
                return response;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/FremdkostenRS.ts